import { useEffect, useState } from 'react';
import cn from 'classnames';
import _ from 'lodash';

import t from 'lib/i18n';
import { enhanceTicketTypeName } from "lib/favourites";
import "styles/components/favourites/favourite-ticket.scss";

import A11yElement from "components/helpers/A11yElement";
import FareClassLabel from 'components/ui/FareClassLabel';
import RemoveFavourite from 'components/favourites/RemoveFavourite';
import Passengers from 'components/favourites/FavouriteTicket/Passengers';
import PlusBus from 'components/favourites/FavouriteTicket/PlusBus';
import { FareClassTypes } from 'components/ui/FareClassLabel';
import { ReactComponent as SingleArrowIcon } from "static/images/single-arrow.svg";
import { ReactComponent as DoubleArrowsIcon } from "static/images/double-arrows.svg";
import { ReactComponent as OpenReturnArrowsIcon } from "static/images/open-return-arrows.svg";
import { ReactComponent as FavouriteIcon } from "static/images/favourite.svg";

const FavouriteTicket = ({ ticket, collapsible = false, onAction = _.noop }) => {
  const {
    origin,
    destination,
    ticketType,
    isOpenReturn,
    duration,
    fareClass = FareClassTypes.STANDARD,
    adults: adultCount,
    children,
    railcards,
    plusBus
  } = ticket;

  let adults = ticket.ticketType.code === 'FL1' ? ticket.passengerCount : adultCount;

  const [isCollapsed, setIsCollapsed] = useState(collapsible);

  useEffect(() => {
    setIsCollapsed(collapsible)
  }, [collapsible]);

  const toggleCollapsed = () => setIsCollapsed(!isCollapsed);

  const ticketCount = adults + children;
  const ticketTypeName = enhanceTicketTypeName(ticketType, duration);
  const hasPlusBus = !_.isEmpty(_.pickBy(plusBus));

  let JourneyIcon = DoubleArrowsIcon;
  if (isOpenReturn) {
    JourneyIcon = OpenReturnArrowsIcon;
  } else if (ticketTypeName.includes('Single')) {
    JourneyIcon = SingleArrowIcon;
  }

  const baseClass = 'otrl-jp__favourite-ticket';
  const classes = cn(baseClass, {
    [`${baseClass}--collapsible`]: collapsible,
    [`${baseClass}--opened`]: !isCollapsed,
  });

  return (
    <A11yElement
      className={classes}
      onAction={collapsible ? toggleCollapsed : onAction}
    >
      <div className={`${baseClass}__header`}>
        <div
          className={`${baseClass}__stations`}
          aria-label={t('favourites.ticket.stations.aria', {
            origin: origin.name,
            destination: destination.name
          })}
        >
          <FavouriteIcon className={`${baseClass}__stations__favourite-icon`} />
          <span className={`${baseClass}__stations__name`}>{origin.name}</span>
          <JourneyIcon className={`${baseClass}__stations__journey-type-icon`} />
          <span className={`${baseClass}__stations__name`}>{destination.name}</span>
        </div>
      </div>
      {!isCollapsed && (
        <div className={`${baseClass}__body`}>
          <div className={`${baseClass}__details`}>
            <div className={`${baseClass}__type`} aria-label={`${ticketTypeName}.`}>
              {ticketTypeName}
            </div>
            <div className={`${baseClass}__fare-class`}>
              <FareClassLabel type={fareClass} />
            </div>
          </div>
          <Passengers adults={adults} children={children} railcards={railcards} />
          {hasPlusBus && (
            <PlusBus
              originName={origin.name}
              destinationName={destination.name}
              terminals={plusBus}
              ticketCount={ticketCount}
            />
          )}
          <div className={`${baseClass}__actions`}>
            <RemoveFavourite ticket={ticket} />
          </div>
        </div>
      )}
    </A11yElement>
  );
};

export default FavouriteTicket;